/* eslint-disable react/prop-types */
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonBadge from "components/ArgonBadge";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ArgonButton from "components/ArgonButton";
import { Link } from "react-router-dom";
import { audienceLabel, scheduleLabel, statusLabel } from "Views/Banner/bannerOptions";

const statusColor = (status) => {
  switch (status) {
    case "ACTIVE":
      return "success";
    case "INACTIVE":
      return "secondary";
    case "PENDING":
      return "warning";
    case "SCHEDULED":
      return "info";
    default:
      return "info";
  }
};

const appNote = (status) => {
  if (status === "ACTIVE") return "Visible on app";
  if (status === "SCHEDULED") return "Shows when the window starts";
  if (status === "PENDING") return "Hidden until active";
  return "Hidden from apps";
};

const BannerTableData = (banners, handleDeleteClick) => ({
  columns: [
    { name: "sno", label: "#", align: "center" },
    { name: "Banner", align: "left" },
    { name: "title", label: "Title", align: "left" },
    { name: "type", label: "Type", align: "left" },
    { name: "audience", label: "Show to", align: "left" },
    { name: "Status", align: "left" },
    { name: "schedule", label: "Schedule", align: "left" },
    { name: "action", label: "Action", align: "center" },
  ],

  rows: banners.map((banner, index) => ({
    sno: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {index + 1}
      </ArgonTypography>
    ),
    Banner: (
      <ArgonBox display="flex" alignItems="center">
        <img
          src={banner.bannerImage}
          alt={banner.title}
          style={{
            width: "120px",
            height: "64px",
            objectFit: "cover",
            borderRadius: "8px",
            border: "1px solid #d2d6da",
            backgroundColor: "#f8fafc",
          }}
        />
      </ArgonBox>
    ),
    title: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {banner.title || "N/A"}
      </ArgonTypography>
    ),
    type: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {banner.bannerType || "N/A"}
      </ArgonTypography>
    ),
    audience: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {audienceLabel(banner.audience, banner.onlyActiveClass)}
      </ArgonTypography>
    ),
    Status: (
      <ArgonBox>
        <ArgonBadge
          variant="gradient"
          badgeContent={statusLabel(banner.status)}
          color={statusColor(banner.status)}
          size="xs"
          container
        />
        <ArgonTypography variant="caption" color="text" display="block" mt={0.5}>
          {appNote(banner.status)}
        </ArgonTypography>
      </ArgonBox>
    ),
    schedule: (
      <ArgonTypography variant="caption" color="text" sx={{ whiteSpace: "normal", maxWidth: 180 }}>
        {scheduleLabel(banner)}
      </ArgonTypography>
    ),
    action: (
      <ArgonBox display="flex" alignItems="center" gap={0}>
        <Link to={`/banner/editbanner/${banner._id}`} style={{ textDecoration: "none" }}>
          <ArgonButton variant="text" size="large" sx={{ minWidth: "12px", p: 0 }}>
            <EditIcon color="info" />
          </ArgonButton>
        </Link>
        <ArgonButton
          variant="text"
          size="large"
          sx={{ minWidth: "32px", p: 0 }}
          onClick={() => handleDeleteClick(banner._id)}
        >
          <DeleteIcon color="error" />
        </ArgonButton>
      </ArgonBox>
    ),
  })),
});

export default BannerTableData;
